(() => {
  const namespace = 'NatureliaFlowHomepage';
  if (window[namespace]) {
    window[namespace].init(document);
    return;
  }

  const calculate = (rawGuests, priceInSubunits) => {
    const value = String(rawGuests).trim();
    if (!/^\d+$/.test(value)) return null;
    const guests = Number(value);
    const price = Number(priceInSubunits);
    if (!Number.isSafeInteger(guests) || guests < 1 || guests > 2400) return null;
    if (!Number.isSafeInteger(price) || price < 0) return null;
    const packs = Math.ceil(guests / 24);
    return { guests, packs, main: packs * 24, dessert: packs * 24, total: packs * price };
  };

  const initPlanner = (panel) => {
    if (panel.dataset.nfhReady === 'true') return;
    const guests = panel.querySelector('[data-nfh-guests]');
    const variants = panel.querySelector('[data-nfh-variant]');
    const error = panel.querySelector('[data-nfh-error]');
    const results = panel.querySelector('[data-nfh-results]');
    const packs = panel.querySelector('[data-nfh-packs]');
    const quantityInstruction = panel.querySelector('[data-nfh-quantity-instruction]');
    const main = panel.querySelector('[data-nfh-main]');
    const dessert = panel.querySelector('[data-nfh-dessert]');
    const total = panel.querySelector('[data-nfh-total]');
    const stock = panel.querySelector('[data-nfh-stock]');
    const link = panel.querySelector('[data-nfh-combo-link]');
    if (![guests, variants, error, results, packs, main, dessert, total, stock, link].every(Boolean)) return;
    let money;
    try {
      money = new Intl.NumberFormat(panel.dataset.locale || document.documentElement.lang || 'en', {
        style: 'currency', currency: panel.dataset.currency, currencyDisplay: 'code'
      });
    } catch {
      return;
    }
    const update = () => {
      const option = variants.selectedOptions[0];
      if (!option) return;
      const result = calculate(guests.value, option.dataset.price);
      guests.setCustomValidity(result ? '' : panel.dataset.invalid);
      guests.setAttribute('aria-invalid', String(!result));
      error.hidden = Boolean(result);
      error.textContent = result ? '' : panel.dataset.invalid;
      results.hidden = !result;
      if (option.dataset.url) link.setAttribute('href', option.dataset.url);
      if (!result) return;
      packs.textContent = String(result.packs);
      if (quantityInstruction) quantityInstruction.textContent = quantityInstruction.dataset.template.replace('__count__', String(result.packs));
      main.textContent = String(result.main);
      dessert.textContent = String(result.dessert);
      total.textContent = money.format(result.total / 100);
      if (option.dataset.available !== 'true') {
        stock.textContent = panel.dataset.stockUnavailable;
      } else if (option.dataset.managed === 'true' && result.packs > Number(option.dataset.stock)) {
        stock.textContent = panel.dataset.stockExceeded;
      } else {
        stock.textContent = panel.dataset.stockReady;
      }
    };
    guests.addEventListener('input', update);
    variants.addEventListener('change', update);
    panel.dataset.nfhReady = 'true';
    update();
  };

  const init = (scope) => {
    if (scope.matches?.('[data-nfh-planner]')) initPlanner(scope);
    scope.querySelectorAll('[data-nfh-planner]').forEach(initPlanner);
  };
  window[namespace] = { init, calculate };
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }
})();
